import { useCallback, useState } from 'react';
import { listingApprovalService } from 'api/services/ListingApprovalService';

const STATUS_APPROVED = 1;
const STATUS_REJECTED = 5;

export function useListingApproval() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const approveListing = useCallback(async (listingId: string) => {
    setLoading(true);
    setError(null);
    try {
      const result = await listingApprovalService.approveOrReject(STATUS_APPROVED, listingId);
      if (!result.isSuccess) {
        setError(result.message ?? 'İlan onaylanamadı.');
      }
      return result;
    } catch (err) {
      const msg = err instanceof Error ? err.message : 'Bir hata oluştu.';
      setError(msg);
      return { isSuccess: false, message: msg, statusCode: 0 };
    } finally {
      setLoading(false);
    }
  }, []);

  const rejectListing = useCallback(async (listingId: string, rejectionReason?: string | null) => {
    setLoading(true);
    setError(null);
    try {
      const result = await listingApprovalService.approveOrReject(STATUS_REJECTED, listingId, {
        rejectionReason: rejectionReason ?? null,
      });
      if (!result.isSuccess) {
        setError(result.message ?? 'İlan reddedilemedi.');
      }
      return result;
    } catch (err) {
      const msg = err instanceof Error ? err.message : 'Bir hata oluştu.';
      setError(msg);
      return { isSuccess: false, message: msg, statusCode: 0 };
    } finally {
      setLoading(false);
    }
  }, []);

  const suspendListing = useCallback(async (listingId: string) => {
    setLoading(true);
    setError(null);
    try {
      const result = await listingApprovalService.suspend(listingId);
      if (!result.isSuccess) {
        setError(result.message ?? 'İlan askıya alınamadı.');
      }
      return result;
    } catch (err) {
      const msg = err instanceof Error ? err.message : 'Bir hata oluştu.';
      setError(msg);
      return { isSuccess: false, message: msg, statusCode: 0 };
    } finally {
      setLoading(false);
    }
  }, []);

  return { approveListing, rejectListing, suspendListing, loading, error };
}
